export const formatTranslationStatus = (status) => {
  if (!status) return '-';
  return String(status).replace(/_/g, ' ');
};

export const getTranslationStatusColor = (status) => {
  switch (status) {
    case 'ACTIVE':
      return 'info';
    case 'COMPLETED':
      return 'success';
    case 'DEGRADED':
    case 'SKIPPED_THAI_SOURCE':
      return 'warning';
    case 'FAILED':
      return 'error';
    default:
      return 'default';
  }
};

export const formatLanguage = (language) => language || '-';

export const formatLatencyMs = (value) => {
  if (typeof value !== 'number' || Number.isNaN(value)) return '-';
  return `${Math.round(value)}ms`;
};

// Trace event times are stored as a BIGINT epoch in milliseconds, which the API sends as a
// string ("1792246372594"); Date() cannot parse that (it gives NaN). Accepts a number, a
// digit string, or a date string, and returns epoch milliseconds or null.
export const parseEventTimestamp = (value) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const text = String(value).trim();
  const parsed = /^\d+$/.test(text) ? Number(text) : new Date(text).getTime();
  return Number.isFinite(parsed) ? parsed : null;
};

// The delay a listener actually feels: from the moment the speaker stopped talking until
// the translated audio starts. Unlike "AI2 Speak Delay" it leaves out how long the
// speaker talked. Both arguments are epoch milliseconds; returns null when either is
// missing or the audio is stamped before the speech ended.
export const computeAfterSpeechDelayMs = (speechEndedAt, audibleAt) => {
  if (!Number.isFinite(speechEndedAt) || !Number.isFinite(audibleAt) || audibleAt < speechEndedAt) {
    return null;
  }
  return audibleAt - speechEndedAt;
};

export const summarizeProviderStatus = (health) => {
  const services = health?.services || {};
  return [
    { key: 'speechToText', label: 'Speech recognition', status: services.speechToText || 'unknown' },
    { key: 'translation', label: 'Text translation', status: services.translation || 'unknown' },
    { key: 'textToSpeech', label: 'Voice generation', status: services.textToSpeech || 'unknown' },
    { key: 'mediaGatewayControl', label: 'Media path control', status: services.mediaGatewayControl || 'unknown' },
  ];
};

export const getDependencyColor = (status) => {
  if (status === 'healthy') return 'success';
  if (status === 'unknown' || status === 'unconfigured') return 'default';
  return 'warning';
};
